import React from "react";
import Color from "color";
import Format from "../../Format";
import Icon from "../../Icon/Icon";
import LinkButton from "../../LinkButton/LinkButton";
import { createLink, date, format } from "../../../utils";
import { useGlobalValue } from "../../../state/GlobalProvider";
import { ExpandableWidget, Link } from "../..";
import styles from "./GenericEntityHeader.module.sass";
import SimpleLink from "../../LinkButton/SimpleLink";
const renderEntry = (label, value, className, key, backgroundColor, color, icon) => {
  const LabelTag = typeof label === "string" ? "h5" : "div";
  const bgColor = backgroundColor ? new Color(backgroundColor) : null;
  const input = color ? {
    color,
    opacity: 0.8,
    backgroundColor: bgColor ? bgColor.lighten(0.1).hex() : null
  } : null;
  const titleStyle = color ? {
    color: color
  } : null;
  const bgStyle = bgColor ? {
    backgroundImage: `linear-gradient(35deg, ${backgroundColor}, ${bgColor.rotate(-10).hex()})`
  } : null;
  return /*#__PURE__*/React.createElement("div", {
    key: key,
    className: styles["entry"],
    style: bgStyle
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: styles["icon-container"]
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles["icon"],
    name: icon
  })), /*#__PURE__*/React.createElement(LabelTag, {
    className: styles["label"],
    style: titleStyle
  }, label), /*#__PURE__*/React.createElement("div", {
    className: `${styles["input"]} ${className || ""}`,
    style: input
  }, value || "N/A"));
};
const renderCols = (row, className, key, params, proxy, i18n) => {
  const cols = (row || []).map((col, colIndex) => {
    if (!col) {
      return null;
    }
    const {
      label,
      value,
      type,
      backgroundColor,
      color,
      icon
    } = col;
    let alignment = "align-left";
    let labelElement = typeof label === "string" ? i18n`${label || ""}` : label;
    let valueElement;
    switch (type) {
      case "number":
        {
          alignment = alignment !== "align-right" ? "align-right" : alignment;
          valueElement = value && value != "null" ? format(value, "normal", null) : "N/A";
          break;
        }
      case "boolean":
        {
          valueElement = !!value === true ? i18n`Yes` : i18n`No`;
          break;
        }
      case "date":
        {
          valueElement = value || "N/A";
          break;
        }
      case "date_interval":
        {
          alignment = alignment !== "align-center" ? "align-center" : alignment;
          valueElement = value ? value.map(v => date(v)).join(" - ") : "N/A";
          break;
        }
      case "currency":
        {
          alignment = alignment !== "currency align-right" ? "currency align-right" : alignment;
          valueElement = /*#__PURE__*/React.createElement(Format, {
            type: type,
            value: value || 0
          });
          break;
        }
      case "percentage":
        {
          alignment = alignment !== "align-right" ? "align-right" : alignment;
          valueElement = `${format((parseFloat(value) || 0).toFixed(2), "normal", null)}%`;
          break;
        }
      case "object":
        {
          if (value.id && value.name) {
            labelElement = /*#__PURE__*/React.createElement(SimpleLink, {
              to: createLink(undefined, proxy, value, params),
              label: i18n`${label || ""}`
            });
            valueElement = value.name;
          }
          break;
        }
      default:
        {
          alignment = "align-left";
          valueElement = `${value && value != "null" ? value : "N/A"}`;
          break;
        }
    }
    return renderEntry(labelElement, valueElement, alignment, colIndex, backgroundColor, color, icon);
  });
  return /*#__PURE__*/React.createElement("div", {
    key: key,
    className: `${className}`
  }, cols.length ? /*#__PURE__*/React.createElement("div", {
    className: `${styles["flex"]} ${cols.length % 2 === 0 ? styles["even"] || "" : styles["odd"] || ""}`
  }, cols) : null);
};
const renderFieldSet = (fieldset, key, params, proxy, i18n) => {
  const groupItems = (fieldset.rows || []).map((row, index) => renderCols(row, styles["fieldset-group"], `fieldset_${index}`, params, proxy, i18n));
  return /*#__PURE__*/React.createElement(ExpandableWidget, {
    key: key,
    className: `${styles["fieldset"]}`,
    title: i18n`${fieldset.title}`
  }, groupItems);
};
const GenericEntityHeader = props => {
  const {
    data,
    modifiers
  } = props;
  const {
    proxy,
    i18n,
    params
  } = useGlobalValue();
  const modifiersClasses = (modifiers || []).map(m => styles[m]).filter(m => m).join(" ");
  const headerRows = data || [];
  const rows = headerRows.map((row, index) => {
    if (!row) {
      return null;
    }
    let className = index === 1 ? styles["grid"] : styles["group-content"];
    if (Array.isArray(row)) {
      return renderCols(row, className, index, params || {}, proxy, i18n);
    } else if (typeof row === "object") {
      return renderFieldSet(row, index, params || {}, proxy, i18n);
    }
    return null;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["root"]} ${modifiersClasses}`
  }, rows);
};
export default GenericEntityHeader;